import { ActionCreator, createReducer, on, ReducerTypes } from '@ngrx/store';
import { asyncStoreItemAdapter } from '@lib/store';
import * as actions from './standby-cancel-result.actions';
import { StandbyCancelResultState } from './standby-cancel-result.state';

/**
 * standbyCancelResult initial state
 */
export const standbyCancelResultInitialState: StandbyCancelResultState = {
  model: null,
  requestIds: [],
};

/**
 * List of basic actions for StandbyCancelResult Store
 */
export const standbyCancelResultReducerFeatures: ReducerTypes<StandbyCancelResultState, ActionCreator[]>[] = [
  on(actions.setStandbyCancelResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest(
      { ...asyncStoreItemAdapter.extractAsyncStoreItem(state), ...payload },
      payload.requestId
    )
  ),

  on(actions.updateStandbyCancelResult, (state, payload) =>
    asyncStoreItemAdapter.resolveRequest({ ...state, ...payload }, payload.requestId)
  ),

  on(actions.resetStandbyCancelResult, () => standbyCancelResultInitialState),

  on(actions.cancelStandbyCancelResultRequest, (state, action) =>
    asyncStoreItemAdapter.resolveRequest(state, action.requestId)
  ),

  on(actions.failStandbyCancelResult, (state, payload) => asyncStoreItemAdapter.failRequest(state, payload.requestId)),

  on(actions.setStandbyCancelResultFromApi, actions.updateStandbyCancelResultFromApi, (state, payload) =>
    asyncStoreItemAdapter.addRequest(state, payload.requestId)
  ),
];

/**
 * StandbyCancelResult Store reducer
 */
export const standbyCancelResultReducer = createReducer(
  standbyCancelResultInitialState,
  ...standbyCancelResultReducerFeatures
);
